import React, { useState } from "react";
import styled from "styled-components";
import { Button } from "../Button/Button";
import { IoIosArrowBack, IoIosArrowDown } from "react-icons/io";
import { BiReset } from "react-icons/bi";

const WirdContainer = styled.div`
  box-shadow: 8px 8px 25px 0px rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;
  transition: 250ms;
  position: relative;

  .button {
    background-color: var(--min-color);
    padding: 20px 15px;
    text-align: right;
    line-height: 1.6;
    position: relative;
    z-index: 5;
    column-gap: 10px;
  }

  .content-wraper {
    height: 0;
  }

  &.active {
    height: auto;

    .button {
      background-color: var(--sec-color);
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      color: var(--min-color);
    }

    .content-wraper {
      height: auto;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
`;

const ContentWrapper = styled.div`
  background-color: var(--sec-color);
  border-radius: 5px;
  transition: 250ms;
  overflow: hidden;
`;

const ContentBox = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CounterBox = styled.div`
  padding: 20px 0 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
  width: 70%;
`;

const StartCount = styled.span`
  color: var(--min-color);
`;

const Counter = styled.div`
  background-color: var(--min-color);
  box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ResetBox = styled.div`
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

// const Reverse = styled.span`
//   width: 30px;
//   height: 30px;
//   padding: 5px;
//   background-color: rgba(var(--min-color-rgba), 0.5);
//   border-radius: 50%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   margin-bottom: 30px;
//   font-size: 11px;
// `;

const Reset = styled.span`
  padding: 5px;
  background-color: rgba(var(--min-color-rgba), 0.5);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
`;

const TextBox = styled.div`
  border-top: 1px solid rgba(var(--min-color-rgba), 0.1);
  cursor: pointer;
  padding: 10px;
`;

const Text = styled.p``;

function Wird({ title, count, counter, reset, text }) {
  const [arrow, setArrow] = useState(false);
  const toggleActive = (e) => {
    e.target.closest(".wird-container").classList.toggle("active");
    setArrow(!arrow);
  };
  return (
    <WirdContainer className="wird-container">
      <Button btnSize="btn--full-width" onClick={toggleActive}>
        {title}
        {arrow ? <IoIosArrowDown /> : <IoIosArrowBack />}
      </Button>
      <ContentWrapper className="content-wraper">
        <ContentBox>
          <CounterBox onClick={count}>
            <StartCount>إضغط لبدء العد</StartCount>
            <Counter>{counter}</Counter>
          </CounterBox>
          <ResetBox>
            <Reset onClick={reset}>
              <BiReset />
            </Reset>
          </ResetBox>
        </ContentBox>
        <TextBox onClick={count}>
          <Text>{text}</Text>
        </TextBox>
      </ContentWrapper>
    </WirdContainer>
  );
}

export default Wird;
